import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { SafetyDialogComponent } from '../safety-dialog/safety-dialog.component';
import { SafetyService } from 'src/app/services/safety.service';
import { BtnDownload } from 'src/app/btn-download.component';
import { TranslaterService } from 'src/app/services/translater.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import { BaseApi } from 'src/backend/api/base-api';

@Component({
  selector: 'app-bos-reporting',
  templateUrl: './bos-reporting.component.html',
  styleUrls: ['./bos-reporting.component.scss']
})
export class BOSReportingComponent implements OnInit {
  isEdit: boolean = false;
  ImageUrl: any;
  user: any;
  breadcrumList: any;
  spinnerText: string = "";

  paginationPageSize!: any;

  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    paginationPageSize: 10,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      BtnRenderer: BtnDownload,
    },
  };
  gridApi!: any;
  gridColumnApi!: any;

  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  BOSReportColumns = [
    { field: 'Description', headerName: 'Description', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'Status', headerName: 'Status', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'Remarks', headerName: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'CreatedOn', headerName: 'Created On', headerValueGetter: this.localizeHeader.bind(this) },
    { field: 'CreatedBy', headerName: 'Created By', headerValueGetter: this.localizeHeader.bind(this) },
  ];

  BOSReportList: any = [];
  isExist: boolean = false;

  langObj: any = {};
  languageDir = 'ltr';
  lang: any;
  moduleId: any;
  pageId: any;

  constructor(
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    public safetyService: SafetyService,
    private translater: TranslaterService,
    private translate: TranslateService,
    private baseApi: BaseApi
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); })
  }

  ngOnInit(): void {
    this.user = localStorage.getItem('user');
    this.user = JSON.parse(this.user);
    this.getLangWords();
  }



  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  applyFilter(event: Event): void {
  }

  getBOSReport(event: any) {
    console.log('getBOSReport');
    this.spinner.show();
    this.spinnerText = "Fetching BOS Report";
    this.safetyService.getBOSReport(event).subscribe((res: any) => {
      this.spinner.hide();
      this.BOSReportList = res.BOSReportList;
      this.isExist = this.BOSReportList && this.BOSReportList.length ? true : false;
      this.getPaginator();
    },
      (error: any) => {
        this.toaster.error(error.error.message);
        this.spinner.hide();
      });
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }


  getPaginator(): void {
    setTimeout(() => {
    }, 100);
  }

  openDialog(event: any, name: any): void {
    let dialogRef = this.dialog.open(SafetyDialogComponent, {
      disableClose: true,
      width: '80%',
      height: '95vh',
      data: {
        headerData: event,
        formName: name,
        isExist: this.isExist
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result == undefined)
        console.log('Undefined Result');
      else
        this.getBOSReport(result);
    });
  }

}
